<template>
  <div>
    <el-form inline class="demo-form-inline" :model="form">
      <el-form-item label="商家 ID">
        <el-input v-model="form.merchantId"></el-input>
      </el-form-item>
      <el-form-item label="商家名称">
        <el-input v-model="form.merchantName"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button @click="onReset">重置</el-button>
        <el-button @click="onExport">导出</el-button>
      </el-form-item>
    </el-form>
    <el-alert
      :title="`汇总 总余额：${description.total}，冻结中：${description.freeze}，可提现余额：${description.balance}`"
      type="info"
      :closable="false"
      show-icon
    >
    </el-alert>
    <el-table :data="tableData" style="width: 100%" v-loading="loading">
      <el-table-column prop="supply_id" label="商家 ID"></el-table-column>
      <el-table-column prop="supply_name" label="商家名称"></el-table-column>
      <el-table-column
        prop="marketing_total_balance"
        label="总余额"
      ></el-table-column>
      <el-table-column
        prop="marketing_freeze_money"
        label="冻结中"
      ></el-table-column>
      <el-table-column
        prop="marketing_balance"
        label="可提现余额"
      ></el-table-column>
      <el-table-column prop="operation" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="viewLog(scope.row.supply_id)"
            >查看日志</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="Number(pagination.total)"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { postMarketingAccountList } from "@/openapi/erp/supplyAccount.js";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "MerchantMarketingAccount",
  data() {
    return {
      form: {
        merchantId: "",
        merchantName: "",
        canExport: false,
      },
      tableData: [],
      pagination: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      description: {
        total: "",
        freeze: "",
        balance: "",
      },
      loading: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    viewLog(supplyId) {
      console.log("viewLog", supplyId);
      this.$router.push({
        path: `/home/merchant-marketing-account-log/${supplyId}`,
      });
    },
    fetchData() {
      this.loading = true;
      let params = {
        supply_id: this.form.merchantId,
        supply_name: this.form.merchantName,
        is_excel: 0,
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize,
      };
      postMarketingAccountList(params)
        .then((res) => {
          console.log("🚀 : postMarketingAccountList : res:", res);
          this.tableData = res.list;
          this.pagination.total = res.total;
          this.description.total = res.total_marketing_total_balance;
          this.description.freeze = res.total_marketing_freeze_money;
          this.description.balance = res.total_marketing_balance;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exportData() {
      console.log("exportData");

      let params = {
        supply_id: this.form.merchantId,
        supply_name: this.form.merchantName,
        is_excel: 1,
      };
      postMarketingAccountList(params).then((res) => {
        console.log("🚀 : postMarketingAccountList : res:", res);
        window.open(apiBaseURL + res.file);
      });
    },
    handleSizeChange(val) {
      console.log(`Each page ${val} lines`);
      this.pagination.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      console.log(`Currently on page ${val}`);
      this.pagination.currentPage = val;
      this.fetchData();
    },
    onSearch() {
      console.log("onSearch");
      this.fetchData();
    },
    onReset() {
      console.log("onReset");
      this.form.merchantId = "";
      this.form.merchantName = "";
    },
    onExport() {
      console.log("onExport!");
      this.exportData();
    },
  },
};
</script>

<style lang="less" scoped>
.pagination {
  margin-top: 20px; /* Adjust as needed */
}
</style>



// WEBPACK FOOTER //
// src/pages/MerchantMarketingAccount/MerchantMarketingAccount.vue